import { FC, PropsWithChildren } from 'react';
import { isFeatureEnabled } from './helpers';

type FeatureGateProps = PropsWithChildren & { feature: Parameters<typeof isFeatureEnabled>[0] };

export const FeatureGate: FC<FeatureGateProps> = ({ feature, children }) => {
  const isEnabled = isFeatureEnabled(feature);

  return isEnabled ? children : null;
};
